import jsPDF from "jspdf";

export const createPDF = (
  ticket,
  product,
  pieces,
  data,
  usedPieces,
  defects,
  proofs
) => {
  var img =
    "data:image/png;base64,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";
  var doc = new jsPDF("p", "px", "a4", false);
  var type = ticket.CB_Gestion_del_ticket__c?.trim();
  doc.setFontSize(24).setFont(undefined, "bold");
  doc.text("REGISTRO DE REPARACIÓN", 180, 50);
  doc.addImage(img, "png", 30, 20, 80, 30);
  doc.line(10, 60, 440, 60);

  /** NÚMERO DE EXPEDIENTE**/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text(ticket.CaseNumber, 370, 80);

  /** FECHA DE LLEGADA **/
  doc.setFontSize(10).setFont(undefined, "normal");
  doc.text("Fecha de llegada:", 360, 95);
  doc.line(330, 100, 420, 100);
  doc.line(330, 120, 420, 120);
  doc.line(330, 100, 330, 120);
  doc.line(420, 100, 420, 120);

  /** CLIENTE **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("CLIENTE", 40, 80);
  doc.setFontSize(10).setFont(undefined, "italic");
  type === "No garantía + recogida" && doc.setTextColor("#E10000");
  type === "No garantía + recogida" && doc.setFontSize(14).setFont(undefined, "bold");
  doc.text(
    ticket.CB_Gestion_del_ticket__c ? type : "",
    90,
    80
  );
  doc.setTextColor("#000000");
  doc.setFontSize(10).setFont(undefined, "normal");
  doc.text("Nombre:", 50, 95);
  doc.setFont(undefined, "bold");
  doc.text(ticket.SuppliedName ? ticket.SuppliedName : "", 83, 95);
  doc.setFont(undefined, "normal");
  doc.text("Ciudad:", 50, 105);
  doc.setFont(undefined, "bold");
  doc.text(ticket.CB_Ciudad__c ? ticket.CB_Ciudad__c : "", 80, 105);

  /** ARTÍCULO **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("ARTÍCULO", 40, 130);
  doc.setFontSize(10).setFont(undefined, "normal");
  doc.text("Producto:", 50, 145);
  doc.setFont(undefined, "bold");
  doc.text(
    product?.CB_Descripcion__c ? product?.CB_Descripcion__c : "",
    85,
    145
  );
  doc.setFont(undefined, "normal");
  doc.text("Fecha de compra:", 50, 155);
  doc.setFont(undefined, "bold");
  doc.text(
    ticket.Fecha_de_compra__c ? ticket.Fecha_de_compra__c : "",
    115,
    155
  );
  doc.setFont(undefined, "normal");
  doc.text("Modelo recibido:", 50, 165);
  doc.setFont(undefined, "bold");
  doc.text(data.received_product, 110, 165);
  doc.line(30, 173, 420, 173);

  /** PIEZAS RECIBIDAS **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("PIEZAS RECIBIDAS", 40, 190);
  doc.setFontSize(10).setFont(undefined, "normal");
  pieces.forEach((piece, index) => {
    doc.text(
      (index + 1).toString() + "- " + piece.label,
      50,
      210 + 10 * (index + 1)
    );
  });
  doc.text("Nº de bultos: ", 40, 205);
  doc.text(data?.bultos ? data.bultos.toString() : "", 85, 205);
  doc.setFont(undefined, "italic");
  doc.setFont(undefined, "bold");
  doc.text(data.estado?.data[0] === 1 ? "PERFECTO ESTADO" : "", 125, 205);
  doc.setFont(undefined, "normal");
  doc.line(90, 270, 340, 270);
  doc.text(
    "Comentarios: " + (data?.observaciones ? data.observaciones : ""),
    50,
    283,
    {
      maxWidth: 150,
    }
  );
  doc.line(210, 180, 210, 380);

  /** DEFECTOS **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("DEFECTOS", 225, 190);
  doc.setFontSize(10).setFont(undefined, "normal");
  defects.defects.forEach((def, index) => {
    doc.text(
      (index + 1).toString() + "- " + def.label,
      235,
      200 + 10 * (index + 1)
    );
  });
  doc.text(
    "Comentarios: " + (defects?.observations ? defects.observations : ""),
    235,
    283,
    {
      maxWidth: 170,
    }
  );
  doc.line(30, 385, 420, 385);

  /** PIEZAS RECIBIDAS **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("PIEZAS UTILIZADAS", 40, 400);
  doc.setFontSize(10).setFont(undefined, "normal");
  usedPieces.forEach((piece, index) => {
    doc.text(
      (index + 1).toString() + "- " + piece.nombre?.substring(0, 50),
      50,
      410 + 10 * (index + 1),
      { maxWidth: 290 }
    );
    doc.text(
      piece.ubicacion +
        " - " +
        piece.referencia +
        " - " +
        piece.cantidad.toString(),
      320,
      410 + 10 * (index + 1)
    );
  });
  doc.line(30, 550, 420, 550);

  /** PIEZAS UTILIZADAS **/
  doc.setFontSize(14).setFont(undefined, "bold");
  doc.text("PRUEBAS ERRÓNEAS", 40, 565);
  doc.setFontSize(10).setFont(undefined, "normal");
  proofs.forEach((proof, index) => {
    doc.text("- " + proof.nombre, 50, 570 + 10 * (index + 1), {
      maxWidth: 300,
    });
  });

  /** FECHA DE SALIDA **/
  doc.setFontSize(10).setFont(undefined, "normal");
  doc.text("Fecha de salida:", 365, 570);
  doc.line(330, 575, 420, 575);
  doc.line(330, 595, 420, 595);
  doc.line(330, 575, 330, 595);
  doc.line(420, 575, 420, 595);

  doc.output("dataurlnewwindow");
};